export const environment = {
  production: true,
  base_url : "https://api-lb.creditfair.in/v0/",
  password : "770A8A65DA156D24EE2A093277530142",
  key : "x2tlf194y0manbe55",
  DISABLE_ERROR:false
};